export default __webpack_public_path__ + "style-osm-800-dd0651f13ad4a8d806b79b9f7bd62944.png";